import FormJaivana from 'dashboard_jaivana_v1';

/**
 *
 * @updateBy Sebastian Rios Echverri
 * Versiones corregidas: 1.01.0054
 */

class CustomRecepcionEnvasadoFinal extends FormJaivana.form {
    constructor(props){
        super(props);

        this.initForm = this.initForm.bind(this);
        this.successDatosFicha = this.successDatosFicha.bind(this);
        this.succesDatosTablaRecepEnv = this.succesDatosTablaRecepEnv.bind(this);
        this.setButtonRecibir = this.setButtonRecibir.bind(this);
        this.setChangeButtonRecibir = this.setChangeButtonRecibir.bind(this);
        this.succesButtonRecibir = this.succesButtonRecibir.bind(this);
        this.uploadTableRecepEnv = this.uploadTableRecepEnv.bind(this);
        this.terminarRecepEnv = this.terminarRecepEnv.bind(this);
        this.verFormula = this.verFormula.bind(this);
        this.successVerFormula = this.successVerFormula.bind(this);
        this.gridOptionsVerFormula = Object.assign({}, this.gridOptions);
    }

    initForm(){
        console.log('CustomRecepcionEnvasadoFinal @version: 1.01.0054 @author: Mario A. @updateBy: Juan Nieto; @updateBy Sebastian Rios Echverri' )

        let datos = {
            datos:{
                value: this.props.data.id_ficha, 
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'iddatos', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successDatosFicha,
            error: this.error_,
            general: this.generalFormatPmv
        });

        /*this.generalFormat.nombre_accion = '447-Servicio_traer_datos_fichas_recepcion_envasado_final'; 
        this.service.send(
        {
            endpoint:this.constant.formConfiguration(),
            method:'GET',
            body:body,
            success:this.successDatosFicha,
            error:this.error_,
            general: this.generalFormat
        });*/

        this.generalFormatPmv = { tipo_servicio: 'prod-fichasenvasadofinalmaterial', operacion: 'porrecibir', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.succesDatosTablaRecepEnv,
            error: this.error_,
            general: this.generalFormatPmv
        });

        /*let bodys = {
                value: this.props.data.id_ficha, 
        }
        this.generalFormat.nombre_accion = '447-servicio_traer_datos_items_tablas'; 
        this.service.send(
        {
        endpoint:this.constant.formConfiguration(),
        method:'GET',
        body:bodys,
        success:this.succesDatosTablaRecepEnv,
        error:this.error_,
        general: this.generalFormat,
        showMessage :false
        });*/

        this.getField('btnTerminarRecepEnv').setClick(this.terminarRecepEnv);
        this.getField('btn_verformula').setClick(this.verFormula);
    }

    verFormula(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'verformula', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successVerFormula,
            error: this.error_,
            showMessage: false,
            general: this.generalFormatPmv
        });
    }

    successVerFormula(data){
        if (data.estado_p === 200 && data.data.length >= 1) {
            this.getField('modal_verformula').handleClickOpen();
            this.getField('tb_verformula').toggle(true);
            this.gridOptionsVerFormula['rowData'] = data.model;
            let configCell = new Map();
            configCell.set('nombre_articulo',{headerName: 'Nombre Artículo'});
            configCell.set('version',{headerName: 'Versión'});
            configCell.set('produccion_formulas_versiones',{headerName: 'Producción Fórmulas Versiones'});
            configCell.set('estado_descripcion',{headerName: 'Estado Descripción'});
            this.getField('tb_verformula').initData(this.gridOptionsVerFormula, configCell);
        }else if (data.estado_p === 404){
            this.alertGeneral.toggle(true,'No hay datos',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }else{
            this.alertGeneral.toggle(true,'Error al consumir el servicio.',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }
    }

    successDatosFicha(data){
        if (data.estado_p === 200 && data.model !== undefined && data.model.length > 0){
            this.getField('listaRecepEnv').setVisible(true);
            this.getField('listaRecepEnv').setItemsFichas(data.model);
        }else{
            this.getField('listaRecepEnv').setVisible(false);
        }

    }

    succesDatosTablaRecepEnv(data){
        if(data.estado_p === 200 && data.model !== undefined && data.model.length > 0){

            this.gridOptions['rowData']=[];
            this.getField('tablaRecepEnv').initData(this.gridOptions);
            this.getField('tablaRecepEnv').toggle(true);
            let configCellcol = new Map();
            configCellcol.set('accion', {cellRenderer:this.setButtonRecibir, field:'Acción'});

            this.gridOptions['rowData'] = data.model;
            this.getField('tablaRecepEnv').initData(this.gridOptions,configCellcol);
        } else{
            this.getField('tablaRecepEnv').toggle(false);
        }

    }

    setButtonRecibir(props){
        let button = document.createElement("input");
        button.onclick = () => this.setChangeButtonRecibir(props.data);
        button.setAttribute("class","buttonStyle");
        button.setAttribute("type","button");
        button.setAttribute("value","Recibir");
        return this.createElementJaivana(button); 
    }

    setChangeButtonRecibir(data){
        let datos = {
            datos:{
                id: data.id
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichasenvasadofinalmaterial', operacion: 'recibir', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.succesButtonRecibir,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '447-Servicio_boton_recibir_material_recepcion_emp'; 
        this.service.send(
        {
            endpoint:this.constant.formConfiguration(),
            method:'PUT',
            body:body,
            success:this.succesButtonRecibir,
            error:this.error_,
            general: this.generalFormat
        });*/
    }

    succesButtonRecibir(data){
        //console.log('entro al successbutonRecibir',data);
        if(data.estado_p === 200){
            this.uploadTableRecepEnv();
        }
    }

    uploadTableRecepEnv(){
        
        let datos = {
            datos:{
                value: this.props.data.id_ficha, 
            }
        }

        this.getField('btnTerminarRecepEnv').setDisabled(false);
        this.generalFormatPmv = { tipo_servicio: 'prod-fichasenvasadofinalmaterial', operacion: 'porrecibir', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.succesDatosTablaRecepEnv,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '447-servicio_traer_datos_items_tablas'; 
        this.service.send(
            {
            endpoint:this.constant.formConfiguration(),
            method:'GET',
            body:bodys,
            success:this.succesDatosTablaRecepEnv,
            error:this.error_,
            general: this.generalFormat,
            showMessage :false
            });*/
    }

    terminarRecepEnv(){
        this.getField('btnTerminarRecepEnv').setDisabled(true);

        let datos = {
            datos:{
                proceso_id:this.props.data.proceso_id,
                actividad_configuracion_id: this.props.data.actividad_configuracion_id,
                actividad_id: this.props.data.actividad_id,
                produccion_fichas_id: this.props.data.id_ficha 
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichasenvasadofinalmaterial', operacion: 'recepcion', operacion_tipo: 'crear' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'POST',
            body: datos,
            success: this.successCloseEstage,
            error: this.error_,
            general: this.generalFormatPmv
        });

        /*this.generalFormat.nombre_accion = '447-Servicio_boton_terminar_recepcion_envasado_final'; 
        this.service.send(
        {
            endpoint:this.constant.formConfiguration(),
            method:'POST',
            body:body,
            success:this.successCloseEstage,
            error:this.error_,
            general: this.generalFormat
        });*/
    }



}

export default CustomRecepcionEnvasadoFinal; 
FormJaivana.addController("prod-recepcionenvasado",CustomRecepcionEnvasadoFinal);